/** Company-wide seasonal theme schedule (programFields row). */
export const SEASONAL_THEMES_FIELD_ID = "a8c3e2f0-5b1d-4e9a-9c7f-2d4e8b1a6f03";

export const SEASONAL_THEMES_FIELD_NAME = "Seasonal Themes";

/** Shared partition key used by all programFields items. */
export const PROGRAM_FIELDS_USER_ID =
  "16d08e02a73ab9d99f7160dc07ffd50c9acd1b275899078c58a144cd7f70788bef9dd8409b2e3f1c875bfd9c30cdd59a";

export const THEME_IDS = [
  "summer",
  "halloween",
  "autumn",
  "thanksgiving",
  "albaniaFlag",
  "winter",
];

/** Overlap priority: higher wins. */
export const THEME_PRIORITY = {
  albaniaFlag: 5,
  winter: 4,
  halloween: 3,
  thanksgiving: 2,
  autumn: 1,
  summer: 1,
};

export const THEME_LABELS = {
  summer: "Verë / Summer",
  halloween: "Halloween",
  autumn: "Vjeshtë / Autumn",
  thanksgiving: "Thanksgiving",
  albaniaFlag: "Dita e Flamurit / Pavarësia",
  winter: "Dimër / Christmas",
};

/** Default effects per pack. */
export const DEFAULT_EFFECTS = {
  summer: { logo: false, overlay: true, modal: true },
  halloween: { logo: true, overlay: true, modal: true },
  autumn: { logo: false, overlay: true, modal: true },
  thanksgiving: { logo: false, overlay: true, modal: true },
  albaniaFlag: { logo: true, overlay: true, modal: true },
  winter: { logo: true, overlay: true, modal: true },
};

/**
 * Default schedule for the current calendar year (and winter into next Jan).
 * Dates are inclusive YYYY-MM-DD in Europe/Tirane.
 * Albania Independence / Flag Day is 28 November.
 */
export function buildDefaultSeasonalThemesOptions(year = new Date().getFullYear()) {
  const next = year + 1;
  return {
    enabled: false,
    timezone: "Europe/Tirane",
    forceThemeId: null,
    themes: [
      {
        id: "summer",
        label: THEME_LABELS.summer,
        startDate: `${year}-06-15`,
        endDate: `${year}-08-31`,
        effects: { ...DEFAULT_EFFECTS.summer },
      },
      {
        id: "autumn",
        label: THEME_LABELS.autumn,
        startDate: `${year}-09-15`,
        endDate: `${year}-10-19`,
        effects: { ...DEFAULT_EFFECTS.autumn },
      },
      {
        id: "halloween",
        label: THEME_LABELS.halloween,
        startDate: `${year}-10-20`,
        endDate: `${year}-11-02`,
        effects: { ...DEFAULT_EFFECTS.halloween },
      },
      {
        id: "thanksgiving",
        label: THEME_LABELS.thanksgiving,
        startDate: `${year}-11-20`,
        endDate: `${year}-11-27`,
        effects: { ...DEFAULT_EFFECTS.thanksgiving },
      },
      {
        id: "albaniaFlag",
        label: THEME_LABELS.albaniaFlag,
        startDate: `${year}-11-28`,
        endDate: `${year}-11-29`,
        effects: { ...DEFAULT_EFFECTS.albaniaFlag },
      },
      {
        id: "winter",
        label: THEME_LABELS.winter,
        startDate: `${year}-12-01`,
        endDate: `${next}-01-07`,
        effects: { ...DEFAULT_EFFECTS.winter },
      },
    ],
  };
}
